import React from 'react';

function AnnouncementSkeleton() {
  return (
    <div className="mx-20 mt-24 flex flex-col gap-24 rounded-16 p-16 shadow-npl-styles-shadow-01 md:flex-row">
      <div className="flex justify-between">
        <div className=" h-[120px] w-[180px] animate-pulse rounded-12 bg-npl-neutral-light-solid-5"></div>
      </div>
      <div>
        <div className="h-24 w-[200px] animate-pulse rounded-4 bg-npl-neutral-light-solid-5"></div>
        <div className="mt-12 h-[12px] w-[300px] animate-pulse rounded-4 bg-npl-neutral-light-solid-5 md:w-[500px]"></div>
        <div className="mt-12 h-[12px] w-[300px] animate-pulse rounded-4 bg-npl-neutral-light-solid-5 md:w-[500px]"></div>
        <div className="mt-12 h-[12px] w-[120px] animate-pulse rounded-4 bg-npl-neutral-light-solid-5 md:w-[250px]"></div>
      </div>
    </div>
  );
}

export default AnnouncementSkeleton;
